import { useLocation, Navigate } from 'react-router-dom';
import { routesPath } from '../../common/constants/routesPath';
import { TOKEN, REFRESH_TOKEN } from '../../common/constants/localStorage';
import { IMPERSONATION_END_REASONS } from '../../common/constants/impersonation';
import { getToken } from '../../services/tokenService';
import { getImpersonationSession, isImpersonationTab } from '../../services/impersonationSession';
import { EndImpersonation } from '../impersonation/EndImpersonation';
import { getLandingVinQuery } from '../../utils/landingHandoff';
import { rememberHandoffLanguage } from '../../utils/handoffLanguage';

function AuthGuard({ children }) {
    const location = useLocation();
    const isAuth = location.pathname.split('/')[1] === 'auth';
    const routeSignIn = `${routesPath.AUTH.PATH}/${routesPath.AUTH.SIGN_IN}`;

    // an impersonation tab is signed in by its session alone (there is no refresh token), and the sign-in, 2FA,
    // password and invitation pages stay closed in it; tokenService reads only the tab's sessionStorage here
    if (isImpersonationTab()) {
        if (!getToken(TOKEN) || !getImpersonationSession()) {
            return <EndImpersonation reason={IMPERSONATION_END_REASONS.ENDED} />;
        }

        return isAuth ? <Navigate to={routesPath.ROOT.DASHBOARD} replace /> : children;
    }

    const isLoggedIn = getToken(TOKEN) && getToken(REFRESH_TOKEN);

    const vinQuery = getLandingVinQuery(new URLSearchParams(location.search));

    if (isAuth) {
        if (!isLoggedIn) return children;
        // SC-QA-36: a signed-in visitor from the landing never reaches LanguageProvider on this page, so the language
        // they came with is kept here, before the redirect drops it; the app's own pages apply it
        rememberHandoffLanguage(new URLSearchParams(location.search).get('lang'));
        return <Navigate to={`${routesPath.ROOT.DASHBOARD}${vinQuery}`} replace />;
    }

    return isLoggedIn ? children : <Navigate to={routeSignIn} replace />;
}

export default AuthGuard;
